<template>
  <b-container class="my-4">
    <b-row v-show="step === 1">
      <b-col cols="12" class="p0">
        <b-img style="width: 100%"
        :src="require('@/assets/images/satmed-alertanos.jpg')"
        fluid
        rounded></b-img>
      </b-col>
      <b-col cols="12" class="text-left">
        <fai class="satmed-social-media m-2" :icon="['fab', 'facebook']" />
        <fai class="satmed-social-media m-2" :icon="['fab', 'twitter']" />
        <fai class="satmed-social-media m-2" :icon="['fab', 'whatsapp']" />
      </b-col>
      <b-col cols="12" class="text-justify my-3">
        <h4>¡Hola!</h4>
        <p>
          Por favor comunícanos la situación de alerta que se está presentando
          en tu barrio o vereda, para que el Sistema de Alertas Tempranas de
          Medellín (SATMED) pueda orientarte adecuadamente respecto a las
          acciones que debes realizar para su superación.
        </p>
        <p>
          Sin embargo, antes de diligenciar el formulario, visita nuestra
          sección pedagógica haciendo
          <a
            href="https://www.medellin.gov.co/irj/portal/medellin?NavigationTarget=navurl://ee3dd8599f579ea9381e7becfcf29c7c"
            target="_blank"
          >clic aquí</a>
          . Allí encontrarás
          información que permitirá orientarte de manera oportuna,
          en caso tal de que tu situación se identifique con las
          preguntas y respuestas que tenemos para ti.
        </p>
      </b-col>
    </b-row>
    <b-form @submit.prevent="enviarFormulario">
      <h2 class="mb-5">¡Alértanos!</h2>
      <transition name="slide-fade">
        <div class="my-3" v-show="step === 1">
          <b-row>
            <b-col>
              <p>
                Te damos la bienvenida al formulario que
                te permitirá informarnos tu situación de alerta.
              </p>
              <p>
                Te invitamos a brindar la información más completa y
                precisa del caso. Así ayudarás al SATMED para que
                realice las acciones necesarias que permitan atender
                la alerta y orientarte oportunamente.
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h2>¿A nombre de quién quieres alertar?</h2>
            </b-col>
          </b-row>
          <!-- Preguntas -->
          <b-row>
            <b-col>
              <b-form-group>
                <b-row class="my-5">
                  <b-col class="text-right">
                    <b-button
                      @click="form.PersonaEnRiesgo = 'personal'"
                      v-b-popover.hover.top="popoverTexts.aNombrePropio"
                      :variant="((form.PersonaEnRiesgo === 'personal')?
                    'success' : 'outline-success'
                    )"
                      size="lg"
                      class="p-3"
                    >
                      <fai :icon="['fa', 'child']" class="mr-2" />A nombre propio
                    </b-button>
                  </b-col>
                  <b-col class="text-left">
                    <b-button
                      @click="form.PersonaEnRiesgo = 'tercero'"
                      v-b-popover.hover.top="popoverTexts.porOtraPersona"
                      :variant="((form.PersonaEnRiesgo === 'tercero')?
                    'success' : 'outline-success'
                    )"
                      size="lg"
                      class="p-3"
                    >
                      <fai :icon="['fa', 'male']" class="mr-2" />Por otra persona
                    </b-button>
                  </b-col>
                </b-row>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Botones -->
          <b-row>
            <b-col>
              <b-form-group class="my-4">
                <b-button
                  variant="outline-primary"
                  :disabled="form.PersonaEnRiesgo === null"
                  @click="next()"
                  v-b-popover.hover.top="popoverTexts.siguiente"
                >Siguiente</b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </transition>
      <transition name="slide-fade">
        <div class="my-3" v-show="step === 2">
          <b-row>
            <b-col>
              <h2>Por favor, informa los datos de la persona en riesgo</h2>
            </b-col>
          </b-row>
          <!-- Preguntas -->
          <b-card class="my-4" v-show="showFormPR || form.personasEnRiesgoList.length === 0">
            <b-card-body>
              <b-row>
                <b-col cols="12" md="12">
                  <!-- Nombre -->
                  <b-form-group
                    label-align-sm="right"
                    label-cols-sm="6"
                    class="legend"
                    :invalid-feedback="feedbacks.nombre"
                    :state="vNombre"
                  >
                    <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                      Nombre completo
                      <fai
                        v-b-popover.hover.top="popoverTexts.nombrePropio"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <template slot="label" v-else>
                      Nombre de la persona en riesgo:
                      <fai
                        v-b-popover.hover.top="popoverTexts.nombreTercero"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <b-form-input
                      id="nombre"
                      v-model="PRSelected.nombre"
                      type="text"
                      ref="PRSelectedNombre"
                      required
                      trim
                      :state="vNombre"
                    ></b-form-input>
                  </b-form-group>
                  <!-- Tipo de Documento -->
                  <b-form-group
                    label
                    label-align-sm="right"
                    label-cols-sm="6"
                    class="legend"
                    :invalid-feedback="feedbacks.tipoDocumento"
                    label-for="tipoDocumento"
                    :state="vTipoDocumento"
                  >
                    <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                      Tipo de documento
                      <fai
                        v-b-popover.hover.top="popoverTexts.tipoDocumentoPropio"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <template slot="label" v-else>
                      Tipo de documento:
                      <fai
                        v-b-popover.hover.top="popoverTexts.tipoDocumentoTercero"
                        :icon="['fa', 'info-circle']"
                      />
                      <div class="nota">
                        Si usted no conoce el tipo de documento de
                        la persona en riesgo, lo pueden dejar en
                        blanco y puede continuar con el
                        diligenciamiento.
                      </div>
                    </template>
                    <b-form-select
                      id="tipoDocumento"
                      :options="tiposDocumentos"
                      v-model="PRSelected.tipoDocumento"
                      :state="vTipoDocumento"
                    ></b-form-select>
                  </b-form-group>
                  <!-- Documento -->
                  <b-form-group
                    label
                    label-align-sm="right"
                    label-cols-sm="6"
                    class="legend"
                    :invalid-feedback="feedbacks.documento"
                    label-for="documento"
                    :state="vDocumento"
                  >
                    <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                      Número de documento
                      <fai
                        v-b-popover.hover.top="popoverTexts.documentoPropio"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <template slot="label" v-else>
                      Número de documento de la persona en riesgo:
                      <fai
                        v-b-popover.hover.top="popoverTexts.documentoTercero"
                        :icon="['fa', 'info-circle']"
                      />
                      <div class="nota">
                        Si usted no conoce el número de documento de
                        la persona en riesgo, lo pueden dejar en
                        blanco y puede continuar con el
                        diligenciamiento.
                      </div>
                    </template>
                    <b-form-input
                      id="documento"
                      v-model="PRSelected.documento"
                      type="text"
                      :state="vDocumento"
                      required
                    ></b-form-input>
                  </b-form-group>
                  <!-- Genero -->
                  <b-form-group
                    label-align-sm="right"
                    label-cols-sm="6"
                    class="legend"
                    :invalid-feedback="invalidFeedback"
                    label-for="genero"
                    :state="vGenero"
                  >
                    <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                      Sexo:
                      <fai
                        v-b-popover.hover.top="popoverTexts.generoPropio"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <template slot="label" v-else>
                      Sexo de la persona en riesgo:
                      <fai
                        v-b-popover.hover.top="popoverTexts.generoTercero"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <b-form-select
                    v-model="PRSelected.genero"
                    :options="generos"
                    :state="vGenero"></b-form-select>
                  </b-form-group>
                  <!-- Orientación sexual -->
                  <b-form-group
                    label-align-sm="right"
                    label-cols-sm="6"
                    class="legend"
                    :invalid-feedback="invalidFeedback"
                    label-for="orientacion"
                    :state="vOrientacion"
                  >
                    <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                      Orientación sexual:
                      <fai
                        v-b-popover.hover.top="popoverTexts.orientacionSexualPropio"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <template slot="label" v-else>
                      Orientación Sexual de la persona en riesgo:
                      <fai
                        v-b-popover.hover.top="popoverTexts.orientacionSexualTercero"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <b-form-select
                      v-model="PRSelected.orientacion"
                      :options="orientacionesSexuales"
                      :state="vOrientacion"
                    ></b-form-select>
                  </b-form-group>
                  <!-- Edad -->
                  <b-form-group
                    label
                    label-align-sm="right"
                    label-cols-sm="6"
                    class="legend"
                    :invalid-feedback="feedbacks.edad"
                    label-for="edad"
                    :state="vEdad"
                  >
                    <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                      Edad:
                      <fai
                        v-b-popover.hover.top="popoverTexts.edadPropio"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <template slot="label" v-else>
                      Edad de la persona en riesgo:
                      <fai
                        v-b-popover.hover.top="popoverTexts.edadTercero"
                        :icon="['fa', 'info-circle']"
                      />
                      <div class="nota">
                        Si usted no conoce la edad de la persona en
                        riesgo, lo pueden dejar en blanco y puede
                        continuar con el diligenciamiento.
                      </div>
                    </template>
                    <b-form-input
                      id="documento"
                      v-model="PRSelected.edad"
                      type="text"
                      :state="vEdad"
                      required
                    ></b-form-input>
                  </b-form-group>
                  <!-- Características diferenciales -->
                  <b-form-group
                    label-align-sm="right"
                    label-cols-sm="6"
                    class="legend text-left"
                    :invalid-feedback="invalidFeedback"
                    label-for="caracteristicasDiferenciales"
                    :state="vCaracteristicas"
                  >
                    <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                      Características diferenciales:
                      <fai
                        v-b-popover.hover.top="popoverTexts.caracteristicasDiferencialesPropio"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <template slot="label" v-else>
                      Características diferenciales de la persona en riesgo:
                      <fai
                        v-b-popover.hover.top="popoverTexts.caracteristicasDiferencialesTercero"
                        :icon="['fa', 'info-circle']"
                      />
                      <div class="nota">
                        Por favor seleccione las características diferenciales de la
                        persona en riesgo. Si no las conoce, continúe con el
                        diligenciamiento.
                      </div>
                    </template>
                    <b-form-checkbox-group
                      v-model="PRSelected.caracteristicasDiferenciales"
                      :options="caracteristicasDiferenciales"
                      stacked
                    ></b-form-checkbox-group>
                  </b-form-group>
                  <!-- Nivel de escolaridad -->
                  <b-form-group
                    label-align-sm="right"
                    label-cols-sm="6"
                    class="legend"
                    :invalid-feedback="invalidFeedback"
                    label-for="nivelEscolaridad"
                    :state="vNivelEscolaridad"
                  >
                    <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                      Nivel de escolaridad:
                      <fai
                        v-b-popover.hover.top="popoverTexts.nivelEscolaridadPropio"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <template slot="label" v-else>
                      Si sabe, por favor indique el nivel de
                      escolaridad que tiene la persona en riesgo:
                      <fai
                        v-b-popover.hover.top="popoverTexts.nivelEscolaridadTercero"
                        :icon="['fa', 'info-circle']"
                      />
                      <div class="nota">
                        Si usted no conoce el nivel de escolaridad de
                        la persona en riesgo, Puede seleccionar la
                        opción “No sabe, no responde
                      </div>
                    </template>
                    <b-form-select
                      v-model="PRSelected.nivelEscolaridad"
                      :options="nivelesDeEscolaridad"
                      :state="vNivelEscolaridad"
                    ></b-form-select>
                  </b-form-group>
                  <!-- Grado escolar -->
                  <b-form-group
                    label-align-sm="right"
                    label-cols-sm="6"
                    class="legend"
                    :invalid-feedback="invalidFeedback"
                    label-for="gradoEscolar"
                    :state="vGradoEscolar"
                    v-show="[1, 2, 3].includes(PRSelected.nivelEscolaridad)"
                  >
                    <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                      Grado escolar:
                      <fai
                        v-b-popover.hover.top="popoverTexts.gradoEscolarPropio"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <template slot="label" v-else>
                      Si sabe, por favor indique el grado escolar que
                      tiene la persona en riesgo:
                      <fai
                        v-b-popover.hover.top="popoverTexts.gradoEscolarTercero"
                        :icon="['fa', 'info-circle']"
                      />
                      <div class="nota">
                        Si usted no conoce el grado escolar de la
                        persona en riesgo, Puede seleccionar la
                        opción “No sabe, no responde
                      </div>
                    </template>
                    <b-form-select
                      v-model="PRSelected.gradoEscolar"
                      :options="gradosEscolares"
                      :state="vGradoEscolar"
                    ></b-form-select>
                  </b-form-group>
                  <!-- Esta esperando bebe -->
                  <b-form-group
                    label-align-sm="right"
                    label-cols-sm="6"
                    class="legend text-left"
                    label-for="esperandoBebe"
                  >
                    <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                      ¿Está esperando bebé?:
                      <fai
                        v-b-popover.hover.top="popoverTexts.esperandoBebePropio"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <template slot="label" v-else>
                      ¿Sabe si la persona que está en riesgo, está
                      esperando bebé?:
                      <fai
                        v-b-popover.hover.top="popoverTexts.esperandoBebeTercero"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <b-form-checkbox
                      v-model="PRSelected.esperandoBebe"
                      value="1"
                      unchecked-value="0"
                      size="lg"
                      switch
                    >{{((PRSelected.esperandoBebe === "1") ? 'Sí' : 'No')}}</b-form-checkbox>
                  </b-form-group>
                  <!-- Numero de hijos -->
                  <b-form-group
                    label-align-sm="right"
                    label-cols-sm="6"
                    class="legend"
                    :invalid-feedback="invalidFeedback"
                    label-for="numeroHijos"
                    :state="vNumeroHijos"
                  >
                    <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                      Indique el número de hijos, si tiene:
                      <fai
                        v-b-popover.hover.top="popoverTexts.numeroHijosPropio"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <template slot="label" v-else>
                      Si sabe, por favor indique el número de hijos que tiene la persona en riesgo:
                      <fai
                        v-b-popover.hover.top="popoverTexts.numeroHijosTercero"
                        :icon="['fa', 'info-circle']"
                      />
                      <div class="nota">
                        Si usted no conoce la cantidad de hijos
                        de la persona en riesgo, Puede dejar el
                        valor en cero.
                      </div>
                    </template>
                    <b-form-select
                      v-model="PRSelected.numeroHijos"
                      :options="numerosHijos"
                      :state="vNumeroHijos"
                    ></b-form-select>
                  </b-form-group>
                  <!-- Comuna donde reside -->
                  <b-form-group
                    label-align-sm="right"
                    label-cols-sm="6"
                    class="legend"
                    :invalid-feedback="feedbacks.comunaResidencia"
                    label-for="comunaResidencia"
                    :state="vComunaResidencia"
                  >
                    <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                      Comuna donde reside la persona en riesgo:
                      <fai
                        v-b-popover.hover.top="popoverTexts.comunaResidenciaPropio"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <template slot="label" v-else>
                      Comuna donde reside la persona en riesgo:
                      <fai
                        v-b-popover.hover.top="popoverTexts.comunaResidenciaTercero"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <b-form-select
                      v-model="PRSelected.comunaResidencia"
                      :options="comunas"
                      :state="vComunaResidencia"
                    ></b-form-select>
                  </b-form-group>
                  <!-- Barrio donde reside -->
                  <b-form-group
                    label-align-sm="right"
                    label-cols-sm="6"
                    class="legend"
                    :invalid-feedback="feedbacks.barrioResidencia"
                    label-for="barrioResidencia"
                    :state="vBarrioResidencia"
                  >
                    <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                      Barrio donde reside la persona en riesgo:
                      <fai
                        v-b-popover.hover.top="popoverTexts.barrioResidenciaPropio"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <template slot="label" v-else>
                      Barrio donde reside la persona en riesgo:
                      <fai
                        v-b-popover.hover.top="popoverTexts.barrioResidenciaTercero"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <b-form-select
                      v-model="PRSelected.barrioResidencia"
                      :options="BarrioResidenciaList"
                      :state="vBarrioResidencia"
                    ></b-form-select>
                  </b-form-group>
                  <!-- Dirección de su residencia -->
                  <b-form-group
                    label-align-sm="right"
                    label-cols-sm="6"
                    class="legend"
                    :invalid-feedback="feedbacks.direccion"
                    :state="vDireccion"
                  >
                    <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                      Dirección donde se presenta la situación de alerta
                      <fai
                        v-b-popover.hover.top="popoverTexts.direccionPropio"
                        :icon="['fa', 'info-circle']"
                      />
                    </template>
                    <template slot="label" v-else>
                      Dirección de residencia de la persona en riesgo:
                      <fai
                        v-b-popover.hover.top="popoverTexts.direccionTercero"
                        :icon="['fa', 'info-circle']"
                      />
                      <div class="nota">
                        Si usted no conoce la dirección de
                        residencia de la persona en riesgo, lo
                        pueden dejar en blanco y continuar con
                        el diligenciamiento.
                      </div>
                    </template>
                    <b-form-input
                      id="direccion"
                      v-model="PRSelected.direccion"
                      type="text"
                      :state="vDireccion"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group>
                    <b-form-checkbox
                    id="proteccionDatos"
                    v-model="PRSelected.proteccionDatos"
                    name="proteccionDatos"
                    value="accepted"
                    unchecked-value="not_accepted"
                    >Sí, acepto la
                    <a href="/Politica_Proteccion_Datos.pdf" target="_blank">
                      Política de Protección de Datos
                    </a>
                    y el
                    <a href="/Decreto_1096_de_2018.pdf" target="_blank">
                      Decreto 1096 de 2018
                    </a>
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
                <b-col cols="12" class="text-center">
                  <b-form-group>
                    <b-button
                    variant="outline-primary"
                    :disabled="vStep2"
                    @click="addPersonaEnRiesgo()">
                      Guardar datos personales
                    </b-button>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
          <!-- Tabla de con las personas registradas  -->
          <b-row class="my-4" v-if="form.personasEnRiesgoList.length > 0">
            <b-col cols="12">
              <b-table
                :items="form.personasEnRiesgoList"
                :fields="personasEnRiesgoFields"
                striped
                responsive="sm"
              >
                <template v-slot:cell(options)="data">
                  <b-button
                  class="mx-2"
                  variant="info"
                  :disabled="PREditing"
                  @click="form.personasEnRiesgoList.splice(data.index, 1)">
                  <fai :icon="['fa', 'trash']" />
                  </b-button>
                  <b-button
                  class="mx-2"
                  variant="info"
                  :disabled="PREditing"
                  @click="
                    editPersonaEnRiesgo(data)
                  ">
                  <fai :icon="['fa', 'edit']" />
                  </b-button>
                </template>
              </b-table>
            </b-col>
            <b-col cols="12" class="text-center mb-4">
              <b-button
              @click="
              showFormPersonaEnRiesgo();
              "
              variant="outline-success"
              >Agregar nueva persona</b-button>
            </b-col>
          </b-row>
          <!-- Botones -->
          <b-row>
            <b-col cols="6" class="text-right">
              <b-form-group>
                <b-button
                variant="outline-primary"
                @click="back()"
                class="mr-auto">Volver</b-button>
              </b-form-group>
            </b-col>
            <b-col cols="6" class="text-left">
              <b-form-group>
                <b-button
                variant="outline-primary"
                :disabled="form.personasEnRiesgoList.length === 0 || PREditing"
                @click="next()">Seguir</b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </transition>
      <transition name="slide-fade">
        <div class="my-3" v-show="step === 3">
          <b-row>
            <b-col>
              <h2>Encuesta para conocer la situación de alerta</h2>
              <p>
                Gracias por brindarnos la información de la(s) persona(s) en riesgo.
                Ahora, te invitamos a responder las siguientes preguntas que nos
                permitirán conocer mejor el caso.
              </p>
            </b-col>
          </b-row>
          <!-- Preguntas -->
          <b-row class="mt-4">
            <b-col cols="12" md="12">
              <!-- Riesgo de violencia sexual -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="invalidFeedback"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  ¿Estoy en riesgo de violencia sexual?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.RiesgoViolenciaSexualPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  ¿Está(n) en riesgo de violencia sexual?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.riesgoViolenciaSexualTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-checkbox
                  v-model="form.enRiesgoViolenciaSexual"
                  value="1"
                  unchecked-value="0"
                  size="lg"
                  switch
                >{{((form.enRiesgoViolenciaSexual === "1") ? 'Si' : 'No')}}</b-form-checkbox>
              </b-form-group>
              <!-- Riesgo de Explotación sexual -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="invalidFeedback"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  ¿Estoy en riesgo de explotación sexual?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.riesgoExplotacionSexualPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  ¿Está(n) en riesgo de explotación sexual?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.riesgoExplotacionSexualTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-checkbox
                  v-model="form.enRiesgoExplotacionSexual"
                  value="1"
                  unchecked-value="0"
                  size="lg"
                  switch
                >{{((form.enRiesgoExplotacionSexual === "1") ? 'Si' : 'No')}}</b-form-checkbox>
              </b-form-group>
              <!-- Reclutando Usando o constriñendo -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="invalidFeedback"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  ¿Creo que me están reclutando, usando, utilizando, constriñendo?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.reclutandoUsandoContriniendoPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  ¿Creo que la(s) está(n) reclutando, usando, utilizando, constriñendo?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.reclutandoUsandoContriniendoTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-checkbox
                  v-model="form.reclutandoUsandoContriniendo"
                  value="1"
                  unchecked-value="0"
                  size="lg"
                  switch
                >{{((form.reclutandoUsandoContriniendo === "1") ? 'Si' : 'No')}}</b-form-checkbox>
              </b-form-group>
              <!-- Debe trabajar -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="invalidFeedback"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  ¿Pienso que debo trabajar?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.debeTrabajarPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  ¿Piensa(n) que debe(n) trabajar?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.debeTrabajarTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-checkbox
                  v-model="form.debeTrabajar"
                  value="1"
                  unchecked-value="0"
                  size="lg"
                  switch
                >{{((form.debeTrabajar === "1") ? 'Si' : 'No')}}</b-form-checkbox>
              </b-form-group>
              <!-- Tiempo en la calle -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="invalidFeedback"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  ¿Permanezco mucho tiempo en la calle?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.tiempoEnLaCallePropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  ¿Permanece(n) mucho tiempo en la calle?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.tiempoEnLaCalleTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-checkbox
                  v-model="form.tiempoEnLaCalle"
                  value="1"
                  unchecked-value="0"
                  size="lg"
                  switch
                >{{((form.tiempoEnLaCalle === "1") ? 'Si' : 'No')}}</b-form-checkbox>
              </b-form-group>
              <!-- Vive en la calle -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="invalidFeedback"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  ¿Actualmente vivo en la calle?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.viveEnLaCallePropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  ¿Actualmente vive(n) en la calle?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.viveEnLaCalleTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-checkbox
                  v-model="form.viveEnLaCalle"
                  value="1"
                  unchecked-value="0"
                  size="lg"
                  switch
                >{{((form.viveEnLaCalle === "1") ? 'Si' : 'No')}}</b-form-checkbox>
              </b-form-group>
              <!-- Problemas con otros -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="invalidFeedback"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  ¿Tengo problemas de convivencia con otras personas?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.problemasConOtrosPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  ¿Tiene(n) problemas de convivencia con otras personas?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.problemasConOtrosTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-checkbox
                  v-model="form.problemasConOtros"
                  value="1"
                  unchecked-value="0"
                  size="lg"
                  switch
                >{{((form.problemasConOtros === "1") ? 'Si' : 'No')}}</b-form-checkbox>
              </b-form-group>
              <!-- Problemas de violencia intrafamiliar -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="invalidFeedback"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  ¿Tengo problemas de violencia intrafamiliar?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.violenciaIntrafamiliarPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  ¿Tiene(n) problemas de violencia intrafamiliar?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.violenciaIntrafamiliarTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-checkbox
                  v-model="form.violenciaIntrafamiliar"
                  value="1"
                  unchecked-value="0"
                  size="lg"
                  switch
                >{{((form.violenciaIntrafamiliar === "1") ? 'Si' : 'No')}}</b-form-checkbox>
              </b-form-group>
              <!-- Goce efectivo de Derechos -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="invalidFeedback"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  ¿Tengo dificultades de goce efectivo de derechos? Por favor elija cuáles:
                  <fai
                    v-b-popover.hover.top="popoverTexts.goceEfectivoDerechosPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  ¿Tiene(n) dificultades de goce efectivo de derechos? Por favor elija cuáles:
                  <fai
                    v-b-popover.hover.top="popoverTexts.goceEfectivoDerechosTerceros"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-checkbox-group
                  v-model="form.goceEfectivoDerechos"
                  :options="derechos"
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
              <!-- Tiene Depresión -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="invalidFeedback"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  ¿Siento depresión, ansiedad u otros
                  problemas relacionados con la salud
                  mental o de ánimo?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.tieneDepresionPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  ¿Parece que tiene(n) depresión, ansiedad u
                  otros problemas relacionados con la
                  salud mental o de ánimo?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.tieneDepresionTerceros"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-checkbox
                  v-model="form.tieneDepresion"
                  value="1"
                  unchecked-value="0"
                  size="lg"
                  switch
                >{{((form.tieneDepresion === "1") ? 'Si' : 'No')}}</b-form-checkbox>
              </b-form-group>
              <!-- Curiosidad Sustancias Psicoactivas -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="invalidFeedback"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  ¿Actualmente siento curiosidad por el
                  consumo de sustancias psicoactivas?:
                  Marihuana, cocaína, popper, 2C-B Tussi
                  b, éxtasis, entre otras:
                  <fai
                    v-b-popover.hover.top="popoverTexts.sustanciasPsicoactivasPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  ¿Parece que siente(n) curiosidad por el
                  consumo de sustancias psicoactivas?:
                  Marihuana, cocaína, popper, 2C-B Tussi
                  b, éxtasis, entre otras:
                  <fai
                    v-b-popover.hover.top="popoverTexts.sustanciasPsicoactivasTerceros"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-checkbox
                  v-model="form.sustanciasPsicoactivas"
                  value="1"
                  unchecked-value="0"
                  size="lg"
                  switch
                >{{((form.sustanciasPsicoactivas === "1") ? 'Si' : 'No')}}</b-form-checkbox>
              </b-form-group>
              <!-- Curiosidad Sustancias Psicoactivas alcohol y tabaco -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="invalidFeedback"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  ¿Actualmente siento curiosidad por el
                  consumo de sustancias psicoactivas?:
                  Alcohol y tabaco:
                  <fai
                    v-b-popover.hover.top="popoverTexts.sustanciasPsicoactivasATPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  ¿Parece que siente(n) curiosidad por el
                  consumo de sustancias psicoactivas?:
                  Alcohol y tabaco:
                  <fai
                    v-b-popover.hover.top="popoverTexts.sustanciasPsicoactivasATTerceros"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-checkbox
                  v-model="form.sustanciasPsicoactivasAT"
                  value="1"
                  unchecked-value="0"
                  size="lg"
                  switch
                >{{((form.sustanciasPsicoactivasAT === "1") ? 'Si' : 'No')}}</b-form-checkbox>
              </b-form-group>
              <!-- Bajo amenaza -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="invalidFeedback"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  ¿Estoy bajo amenaza?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.bajoAmenazaPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  ¿Está(n) bajo amenaza?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.bajoAmenazaTerceros"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-checkbox
                  v-model="form.bajoAmenaza"
                  value="1"
                  unchecked-value="0"
                  size="lg"
                  switch
                >{{((form.bajoAmenaza === "1") ? 'Si' : 'No')}}</b-form-checkbox>
              </b-form-group>
              <!-- Peligro de muerte -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="invalidFeedback"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  ¿Estoy en peligro de muerte?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.peligroMuertePropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  ¿Está(n) en peligro de muerte?:
                  <fai
                    v-b-popover.hover.top="popoverTexts.peligroMuerteTerceros"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-checkbox
                  v-model="form.peligroMuerte"
                  value="1"
                  unchecked-value="0"
                  size="lg"
                  switch
                >{{((form.peligroMuerte === "1") ? 'Si' : 'No')}}</b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Botones -->
          <b-row>
            <b-col cols="6" class="text-right">
              <b-form-group>
                <b-button
                variant="outline-primary"
                @click="back()"
                class="mr-auto">Volver</b-button>
              </b-form-group>
            </b-col>
            <b-col cols="6" class="text-left">
              <b-form-group>
                <b-button variant="outline-primary" @click="next()">Siguiente</b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </transition>
      <transition name="slide-fade">
        <div class="my-3" v-show="step === 4">
          <b-row>
            <b-col>
              <h2>Información de la alerta</h2>
              <p>
                  Gracias por responder la encuesta anterior.
                  Ahora, escribe de una manera resumida pero detallada,
                  la situación de alerta.
              </p>
              <p>
                Recuerda también indicar el lugar y
                adjuntar material probatorio en caso de
                tenerlo.
              </p>
            </b-col>
          </b-row>
          <!-- Preguntas -->
          <b-row class="mt-4">
            <b-col cols="12" md="12">
              <!-- Descripción detallada -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="feedbacks.informacionDetalladaAlerta"
                :state="vInformacionDetalladaAlerta"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  Información detallada de la alerta:
                  <fai
                    v-b-popover.hover.top="popoverTexts.informacionDetalladaAlertaPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  Información detallada de la alerta:
                  <fai
                    v-b-popover.hover.top="popoverTexts.informacionDetalladaAlertaTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>

                <b-form-textarea
                  v-model="form.informacionDetalladaAlerta"
                  max-rows="6"
                  rows="3"
                  :state="vInformacionDetalladaAlerta"
                ></b-form-textarea>
              </b-form-group>
              <!-- Lugar situacion alerta -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="feedbacks.lugarSituacionAlerta"
                :state="vLugarSituacionAlerta"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  Lugar donde ocurre la situación de alerta:
                  <fai
                    v-b-popover.hover.top="popoverTexts.lugarSituacionAlertaPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  Lugar donde ocurre la situación de alerta:
                  <fai
                    v-b-popover.hover.top="popoverTexts.lugarSituacionAlertaTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-select
                  v-model="form.lugarSituacionAlerta"
                  :options="lugaresSituacionAlerta"
                  :state="vLugarSituacionAlerta"
                ></b-form-select>
              </b-form-group>
              <!-- Lugar situacion alerta Otro -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="feedbacks.lugarSituacionAlertaOtro"
                :state="vLugarSituacionAlertaOtro"
                v-show="form.lugarSituacionAlerta === 5"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  Lugar donde ocurre la situación de alerta:
                  <fai
                    v-b-popover.hover.top="popoverTexts.lugarSituacionAlertaOtroPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  Lugar donde ocurre la situación de alerta:
                  <fai
                    v-b-popover.hover.top="popoverTexts.lugarSituacionAlertaOtroTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-input
                  v-model="form.lugarSituacionAlertaOtro"
                  type="text"
                  trim
                  required
                  :state="vLugarSituacionAlertaOtro"
                ></b-form-input>
              </b-form-group>
              <!-- Dirección donde ocurre la alerta -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="feedbacks.direccionSituacionAlerta"
                :state="vdireccionSituacionAlerta"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  Dirección donde ocurre la alerta:
                  <fai
                    v-b-popover.hover.top="popoverTexts.direccionSituacionAlertaPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  Dirección donde ocurre la alerta:
                  <fai
                    v-b-popover.hover.top="popoverTexts.direccionSituacionAlertaTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-input
                  v-model="form.direccionSituacionAlerta"
                  type="text"
                  trim
                  required
                  :state="vdireccionSituacionAlerta"
                ></b-form-input>
              </b-form-group>
              <!-- Material Probatorio -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="feedbacks.materialProbatorio"
                :state="vFile"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  Material probatorio:
                  <fai
                    v-b-popover.hover.top="popoverTexts.materialProbatorioPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  Material probatorio:
                  <fai
                    v-b-popover.hover.top="popoverTexts.materialProbatorioTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-row>
                  <b-col cols="12" md="10">
                    <b-form-file
                      v-model="file"
                      :state="vFile"
                      placeholder="Seleccione o arrastre aquí un archivo"
                      browse-text="Explorar"
                    ></b-form-file>
                  </b-col>
                  <b-col cols="12" md="2">
                    <b-button
                      type="button"
                      block
                      @click="addFile"
                      v-b-popover.hover.top="'Haga clic aquí para cargar el archivo'"
                    >
                      <fai :icon="['fa', 'file-upload']" />
                    </b-button>
                  </b-col>
                </b-row>
                <b-row v-if="form.materialProbatorio.length">
                  <b-col
                    cols="12"
                    md="6"
                    class="pt-3"
                    v-for="(document, index) in form.materialProbatorio"
                    v-bind:key="index"
                  >
                    <div class="file-box shadow-sm p-3">
                      <fai :icon="['fa', 'archive']" />
                      {{document.name}}
                      <span
                        style="font-weight: normal"
                      >({{(Math.round((document.size*0.000001)*10))/10}} MB)</span>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-else>
                  <b-col class="p-2">Aun no ha seleccionado ningún archivo</b-col>
                </b-row>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Botones -->
          <b-row>
            <b-col cols="6" class="text-right">
              <b-form-group>
                <b-button
                variant="outline-primary"
                @click="back()"
                class="mr-auto">Volver</b-button>
              </b-form-group>
            </b-col>
            <b-col cols="6" class="text-left">
              <b-form-group>
                <b-button
                variant="outline-primary"
                :disabled="vStep3"
                @click="next()">Siguiente</b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </transition>
      <transition name="slide-fade">
        <div class="my-3" v-show="step === 5">
          <b-row>
            <b-col>
              <h2>Información de contacto de quien informa la alerta</h2>
              <p>
                Gracias por brindar la información detallada acerca de
                la situación de alerta. A continuación, diligencia la
                información que permita ponernos en contacto contigo
                en caso de ser necesario.
              </p>
            </b-col>
          </b-row>
          <!-- Preguntas -->
          <b-row class="mt-4">
            <b-col cols="12" md="12">
              <!-- Alerta anonima -->
              <b-form-group
              label-align-sm="right"
              label-cols-sm="6"
              class="legend text-left"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo !== 'personal'">
                  Registrar alerta Anónima:
                </template>
                <b-form-checkbox
                switch
                v-model="anonimo"
                :value="true"
                :unchecked-value="false">
                </b-form-checkbox>
              </b-form-group>
              <!-- Nombre de Contacto -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="feedbacks.nombreContacto"
                :state="vNombreContacto"
                v-if="form.PersonaEnRiesgo !== 'personal'"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  Nombre completo:
                  <fai
                    v-b-popover.hover.top="popoverTexts.nombreContactoPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  Nombre completo:
                  <fai
                    v-b-popover.hover.top="popoverTexts.nombreContactoTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-input
                  v-model="form.nombreContacto"
                  type="text"
                  required
                  :state="vNombreContacto"
                ></b-form-input>
              </b-form-group>
              <!-- Tipo de Documento -->
              <b-form-group
                label
                label-align-sm="right"
                label-cols-sm="6"
                class="legend"
                :invalid-feedback="feedbacks.tipoDocumentoContacto"
                label-for="tipoDocumento"
                :state="vTipoDocumentoContacto"
                v-if="form.PersonaEnRiesgo !== 'personal'"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  Tipo de documento
                  <fai
                    v-b-popover.hover.top="popoverTexts.tipoDocumentoContactoPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  Tipo de documento:
                  <fai
                    v-b-popover.hover.top="popoverTexts.tipoDocumentoContactoTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-select
                  id="tipoDocumento"
                  :options="tiposDocumentos"
                  v-model="form.tipoDocumentoContacto"
                  :state="vTipoDocumentoContacto"
                ></b-form-select>
              </b-form-group>
              <!-- Documento Contacto -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="feedbacks.documentoContacto"
                :state="vDocumentoContacto"
                v-if="form.PersonaEnRiesgo !== 'personal'"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  Número de documento:
                  <fai
                    v-b-popover.hover.top="popoverTexts.documentoContactoPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  Número de documento:
                  <fai
                    v-b-popover.hover.top="popoverTexts.documentoContactoTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>

                <b-form-input
                  v-model="form.documentoContacto"
                  type="text"
                  required
                  :state="vDocumentoContacto"
                ></b-form-input>
              </b-form-group>
              <!-- Genero Contacto -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="feedbacks.documentoContacto"
                :state="vGeneroContacto"
                v-if="form.PersonaEnRiesgo !== 'personal'"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  Sexo:
                  <fai
                    v-b-popover.hover.top="popoverTexts.generoContactoPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  Sexo:
                  <fai
                    v-b-popover.hover.top="popoverTexts.generoContactoTecero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>

                <b-form-select
                  v-model="form.generoContacto"
                  :options="generos"
                  :state="vGeneroContacto"
                ></b-form-select>
              </b-form-group>
              <!-- Edad Contacto -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="feedbacks.edadContacto"
                :state="vEdadContacto"
                v-if="form.PersonaEnRiesgo !== 'personal'"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  Edad:
                  <fai
                    v-b-popover.hover.top="popoverTexts.edadContactoPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  Edad:
                  <fai
                    v-b-popover.hover.top="popoverTexts.edadContactoTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>

                <b-form-input
                  v-model="form.edadContacto"
                  type="text"
                  required
                  :state="vEdadContacto"
                ></b-form-input>
              </b-form-group>
              <!-- Comuna Contacto -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="feedbacks.comunaContacto"
                :state="vComunaContacto"
                v-if="form.PersonaEnRiesgo !== 'personal'"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  Comuna donde resides:
                  <fai
                    v-b-popover.hover.top="popoverTexts.comunaContactoPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  Comuna donde resides:
                  <fai
                    v-b-popover.hover.top="popoverTexts.comunaContactoTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-select
                  v-model="form.comunaContacto"
                  :options="comunas"
                  :state="vComunaContacto"
                ></b-form-select>
              </b-form-group>
              <!-- Barrio Contacto -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="feedbacks.barrioContacto"
                :state="vBarrioContacto"
                v-if="form.PersonaEnRiesgo !== 'personal'"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  Barrio donde resides:
                  <fai
                    v-b-popover.hover.top="popoverTexts.barrioContactoPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  Barrio donde resides:
                  <fai
                    v-b-popover.hover.top="popoverTexts.barrioContactoTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <b-form-select
                  v-model="form.barrioContacto"
                  :options="BarrioContactoList"
                  :state="vBarrioContacto"
                ></b-form-select>
              </b-form-group>
              <!-- Correo de Contacto -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="feedbacks.correoContacto"
                :state="vCorreoContacto || vTelefonoContacto"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  Correo electrónico:
                  <fai
                    v-b-popover.hover.top="popoverTexts.correoContactoPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  Correo electrónico:
                  <fai
                    v-b-popover.hover.top="popoverTexts.correoContactoTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>

                <b-form-input
                  v-model="form.correoContacto"
                  type="email"
                  required
                  :state="vCorreoContacto || vTelefonoContacto"
                ></b-form-input>
              </b-form-group>
              <!-- Correo de Contacto Confirm -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="feedbacks.correoContactoConfirm"
                :state="vCorreoContactoConfirm || vTelefonoContacto"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  Confirma tu correo electrónico:
                  <fai
                    v-b-popover.hover.top="popoverTexts.correoContactoConfirmPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  Confirma tu correo electrónico:
                  <fai
                    v-b-popover.hover.top="popoverTexts.correoContactoConfirmTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>

                <b-form-input
                  v-model="form.correoContactoConfirm"
                  type="email"
                  required
                  :state="vCorreoContactoConfirm || vTelefonoContacto"
                ></b-form-input>
              </b-form-group>
              <!-- Telefono Contacto -->
              <b-form-group
                label-align-sm="right"
                label-cols-sm="6"
                class="legend text-left"
                :invalid-feedback="feedbacks.telefonoContacto"
                :state="vTelefonoContacto || vCorreoContactoConfirm"
              >
                <template slot="label" v-if="form.PersonaEnRiesgo === 'personal'">
                  Teléfono de contacto:
                  <fai
                    v-b-popover.hover.top="popoverTexts.telefonoContactoPropio"
                    :icon="['fa', 'info-circle']"
                  />
                </template>
                <template slot="label" v-else>
                  Teléfono de contacto:
                  <fai
                    v-b-popover.hover.top="popoverTexts.telefonoContactoTercero"
                    :icon="['fa', 'info-circle']"
                  />
                </template>

                <b-form-input
                  v-model="form.telefonoContacto"
                  type="text"
                  required
                  :state="vTelefonoContacto || vCorreoContactoConfirm"
                ></b-form-input>
              </b-form-group>
              <!-- Aceptación de politica de datos personales -->
              <b-form-group>
                <b-form-checkbox
                id="proteccionDatosGeneral"
                v-model="form.proteccionDatos"
                name="proteccionDatosGeneral"
                value="accepted"
                unchecked-value="not_accepted"
                >Sí, acepto la
                <a href="/Politica_Proteccion_Datos.pdf" target="_blank">
                  Politica de protección de datos
                </a>
                y el
                <a href="/Decreto_1096_de_2018.pdf" target="_blank">
                  Decreto 1096 de 2018
                </a>
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <!-- Botones -->
          <b-row>
            <b-col cols="6" class="text-right">
              <b-form-group>
                <b-button
                variant="outline-primary"
                @click="back()"
                class="mr-auto">Volver</b-button>
              </b-form-group>
            </b-col>
            <b-col cols="6" class="text-left">
              <b-form-group>
                <b-button
                variant="outline-primary"
                :disabled="vStep5"
                @click="next()">Siguiente</b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </transition>
      <transition name="slide-fade">
        <div class="my-3" v-show="step === 6">
          <b-row>
            <b-col>
              <h2>Verifica la información de tu alerta</h2>
              <p>
                Gracias por informar la situación de alerta.
                Esto permitirá brindarte una atención ajustada
                a tu caso particular.
              </p>
              <p>
                Por favor verifica la información que estás a punto de enviar.
              </p>
            </b-col>
          </b-row>
          <!-- Lista de respuestas -->
          <b-row v-for="(seccion, index) in camposVerificables" v-bind:key="index" class="p-3">
            <b-col class="mt-3">
              <h4>
                {{seccion.nombreSeccion}}
                <b-button
                  @click="step = seccion.step"
                  size="sm"
                  variant="outline-info"
                  v-b-popover.hover.top="'Editar las respuestas de esta sección'"
                >Editar</b-button>
              </h4>
              <b-row
                v-for="(campo, index_campo) in seccion.campos"
                v-bind:key="index_campo"
                v-show="campo.disabled !== true"
              >
                <b-col
                  cols="12"
                  md="6"
                  class="text-justify text-md-right p-2"
                  v-if="campo.label !== null"
                >
                  <b>{{campo.label}}:</b>
                </b-col>
                <b-col
                v-if="campo.type=='list'"
                class="text-left dato-box p-2">
                  <ul v-if="campo.value.length">
                    <li
                      v-for="(li, i) in campo.value"
                      v-bind:key="i"
                    >{{ campo.keys.find((e) => e.value === li).text }}</li>
                  </ul>
                  <span v-else>No ha seleccionado ninguna opción</span>
                </b-col>
                <b-col
                  cols="12"
                  md="6"
                  v-else-if="campo.type=='files'"
                  class="text-left dato-box p-2"
                >
                  <ul v-if="campo.value.length">
                    <li v-for="(li, i) in campo.value" v-bind:key="i">{{ li.name }}</li>
                  </ul>
                  <span v-else>No ha seleccionado ningún archivo</span>
                </b-col>
                <b-col
                  cols="12"
                  md="6"
                  v-else-if="campo.type=='checkbox'"
                  class="text-left dato-box p-2"
                >
                  <fai
                    v-if="campo.value==1"
                    :icon="['fa', 'check-circle']"
                    v-b-popover.hover.top="'Si'"
                    class="text-success"
                  />
                  <fai
                    v-else
                    v-b-popover.hover.top="'No'"
                    class="text-warning"
                    :icon="['fa', 'minus-circle']"
                  />
                </b-col>
                <b-col
                cols="12"
                md="6"
                v-else
                class="text-left dato-box p-2">{{campo.value}}</b-col>
              </b-row>
            </b-col>
          </b-row>
          <!-- Botones -->
          <b-row>
            <b-col cols="6" class="text-right">
              <b-form-group>
                <b-button
                variant="outline-primary"
                @click="back()"
                class="mr-auto">Volver</b-button>
              </b-form-group>
            </b-col>
            <b-col cols="6" class="text-left">
              <b-form-group>
                <b-button
                variant="outline-success"
                @click="enviarFormulario()"
                :disabled="sending">
                <span v-if="sending">Enviando la alerta...</span>
                <span v-else>Enviar Alerta</span>
                </b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </transition>
      <transition name="slide-fade">
        <div class="my-5" v-show="step === 'success'">
          <b-row>
            <b-col class="my-5">
              <h2>
                <p>
                  La alerta fue almacenada exitosamente y recibida
                  por el Sistema de Alertas Tempranas de Medellín,
                  quien se encargará de su debida gestión.
                </p>
                <p>
                  Recuerda el siguiente número de radicado para que
                  puedas realizar el seguimiento a la gestión de tu alerta:
                  <b>{{radicado}}</b>
                </p>
              </h2>
              <h1 class="text-success mt-4">
                <fai :icon="['fa', 'check']"></fai>
              </h1>
            </b-col>
          </b-row>
        </div>
      </transition>
      <transition name="slide-fade">
        <div class="my-5" v-show="step === 'error'">
          <b-row>
            <b-col class="my-5">
              <h2>Ocurrió un error intentando almacenar la información</h2>
              <h1 class="text-danger mt-4">
                <fai :icon="['fa', 'times']"></fai>
              </h1>
            </b-col>
          </b-row>
        </div>
      </transition>
      <p v-show="true">
        <b-button class="mx-2" @click="step=1">1</b-button>
        <b-button class="mx-2" @click="step=2">2</b-button>
        <b-button class="mx-2" @click="step=3">3</b-button>
        <b-button class="mx-2" @click="step=4">4</b-button>
        <b-button class="mx-2" @click="step=5">5</b-button>
        <b-button class="mx-2" @click="step=6">6</b-button>
        <b-button class="mx-2" @click="step='success'">Success</b-button>
        <b-button class="mx-2" @click="step='error'">Error</b-button>
      </p>
    </b-form>
  </b-container>
</template>

<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */

import { expresiones } from '@/assets/expresionesRegulares';
import Axios from 'axios';

const popoverTexts = {
  aNombrePropio: 'Elija esta opción si usted es la persona que se identifica en riesgo.',
  porOtraPersona: 'Elija esta opción si usted ha identificado a otra persona en situación de riesgo. Puede ser una persona conocida, cercana o alguien de su familia.',
  siguiente: 'Presionando este botón usted continuará la navegación a través de este formulario.',
  nombrePropio: 'Escriba aquí su nombre completo',
  nombreTercero: 'Escriba aquí el nombre completo de la persona que usted identifica en riesgo o alerta',
  tipoDocumentoPropio: 'Escriba aquí su tipo de documento',
  tipoDocumentoTercero: 'Escriba aquí el tipo de documento de la persona que usted identifica en riesgo o alerta',
  documentoPropio: 'Escriba aquí su número de documento',
  documentoTercero: 'Escriba aquí el número de documento de la persona que usted identifica en riesgo o alerta',
  generoPropio: 'Escriba aquí el género con el cual usted se identifica.',
  generoTercero: 'Escriba aquí el género de la persona que usted identifica en riesgo o alerta',
  orientacionSexualPropio: 'Escriba aquí la orientación sexual con el cual usted se identifica.',
  orientacionSexualTercero: 'Escriba aquí la orientación sexual de la persona que usted identifica en riesgo o alerta',
  edadPropio: 'Escriba aquí en números su edad',
  edadTercero: 'Escriba aquí en números la edad de la persona que usted identifica en riesgo o alerta',
  caracteristicasDiferencialesPropio: 'Por favor seleccione las características diferenciales de la persona en riesgo. Si no las conoce, continúe con el diligenciamiento.',
  caracteristicasDiferencialesTercero: 'Por favor seleccione las características diferenciales de la persona en riesgo. Si no las conoce, continúe con el diligenciamiento.',
  gradoEscolarPropio: 'Por favor indique aquí su grado escolar',
  gradoEscolarTercero: 'Por favor indique aquí el grado escolar que tiene la persona que usted identifica en riesgo o alerta en caso de saberlo',
  nivelEscolaridadPropio: 'Por favor indique aquí su nivel de escolaridad.',
  nivelEscolaridadTercero: 'Por favor indique aquí el nivel de escolaridad que tiene la persona que usted identifica en riesgo o alerta en caso de saberlo',
  esperandoBebePropio: 'Seleccione esta casilla si usted se encuentra esperando bebé.',
  esperandoBebeTercero: 'Seleccione esta casilla si usted observa que la persona en riesgo está esperando bebé',
  numeroHijosPropio: 'Si tiene, indique por favor el número de hijos que usted tiene',
  numeroHijosTercero: 'Por favor indique aquí el número de hijos que tiene la persona que usted identifica en riesgo o alerta en caso de saberlo',
  comunaResidenciaPropio: 'Seleccione aquí la comuna donde usted reside actualmente',
  comunaResidenciaTercero: 'Seleccione aquí la comuna de residencia de la persona que usted identifica en riesgo o alerta',
  barrioResidenciaPropio: 'Seleccione aquí el barrio donde usted reside actualmente',
  barrioResidenciaTercero: 'Seleccione aquí el barrio de residencia de la persona que usted identifica en riesgo o alerta',
  direccionPropio: 'Escriba aquí la dirección de su lugar de residencia',
  direccionTercero: 'Escriba aquí la dirección de residencia de la persona que usted identifica en riesgo o alerta',
  riesgoViolenciaSexualPropio: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  riesgoViolenciaSexualTercero: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  riesgoExplotacionSexualPropio: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  riesgoExplotacionSexualTercero: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  reclutandoUsandoContriniendoPropio: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  reclutandoUsandoContriniendoTercero: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  debeTrabajarPropio: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  debeTrabajarTercero: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  tiempoEnLaCallePropio: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  tiempoEnLaCalleTercero: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  viveEnLaCallePropio: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  viveEnLaCalleTercero: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  problemasConOtrosPropio: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  problemasConOtrosTercero: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  violenciaIntrafamiliarPropio: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  violenciaIntrafamiliarTercero: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  goceEfectivoDerechosPropio: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  goceEfectivoDerechosTerceros: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  tieneDepresionPropio: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  tieneDepresionTerceros: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  sustanciasPsicoactivasPropio: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  sustanciasPsicoactivasTerceros: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  sustanciasPsicoactivasATPropio: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  sustanciasPsicoactivasATTerceros: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  bajoAmenazaPropio: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  bajoAmenazaTerceros: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  peligroMuertePropio: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  peligroMuerteTerceros: 'Seleccione esta opción si usted considera que esta situación le predispone al riesgo.',
  informacionDetalladaAlertaPropio: 'Escriba aquí la información donde usted explica la situación de alerta, tenga en cuenta: Qué situación es, donde ocurre, desde cuando ocurre, quiénes podrían ser las personas que intervienen en el evento problemático o delito y otras características que usted considere.',
  informacionDetalladaAlertaTercero: 'Escriba aquí la información donde usted explica la situación de alerta, tenga en cuenta: Qué situación es, donde ocurre, desde cuando ocurre, quiénes podrían ser las personas que intervienen en el evento problemático o delito y otras características que usted considere.',
  lugarSituacionAlertaPropio: '',
  lugarSituacionAlertaTercero: '',
  lugarSituacionAlertaOtroPropio: 'Escriba aquí en sus propias palabras el lugar donde ocurre la situación de alerta, puede ser la descripción de un parque, zona cercana o nombre que le tienen al lugar.',
  lugarSituacionAlertaOtroTercero: 'Escriba aquí en sus propias palabras el lugar donde ocurre la situación de alerta, puede ser la descripción de un parque, zona cercana o nombre que le tienen al lugar.',
  direccionSituacionAlertaPropio: '',
  direccionSituacionAlertaTercero: '',
  materialProbatorioPropio: 'Por favor adjunte la información que usted crea necesaria como prueba para documentar mucho mejor la alerta. Tenga en cuenta que se permiten los siguientes archivos: .jpg, .jpeg, .gif, .png, .doc, .pdf. Y estos no deben superar un peso máximo de archivo superior a 16 Mb',
  materialProbatorioTercero: 'Por favor adjunte la información que usted crea necesaria como prueba para documentar mucho mejor la alerta. Tenga en cuenta que se permiten los siguientes archivos: .jpg, .jpeg, .gif, .png, .doc, .pdf. Y estos no deben superar un peso máximo de archivo superior a 16 Mb',
  nombreContactoPropio: 'Escriba aquí su nombre completo',
  nombreContactoTercero: 'Escriba aquí su nombre completo',
  tipoDocumentoContactoPropio: 'Indique aquí su tipo de documento',
  tipoDocumentoContactoTercero: 'Indique aquí su tipo de documento',
  documentoContactoPropio: 'Escriba aquí su número de documento.',
  documentoContactoTercero: 'Escriba aquí su número de documento.',
  generoContactoPropio: 'Escriba aquí el género con el cual usted se identifica.',
  generoContactoTecero: 'Escriba aquí el género con el cual usted se identifica.',
  edadContactoPropio: 'Escriba aquí en números su edad cumplida en años.',
  edadContactoTercero: 'Escriba aquí en números su edad cumplida en años.',
  comunaContactoPropio: 'Seleccione aquí la comuna donde usted reside actualmente',
  comunaContactoTercero: 'Seleccione aquí la comuna donde usted reside actualmente',
  barrioContactoPropio: 'Seleccione aquí el barrio donde usted reside actualmente.',
  barrioContactoTercero: 'Seleccione aquí el barrio donde usted reside actualmente.',
  correoContactoPropio: 'Escriba aquí su dirección de correo electrónico',
  correoContactoTercero: 'Escriba aquí su dirección de correo electrónico',
  correoContactoConfirmPropio: 'Escriba aquí de nuevo su dirección de correo electrónico',
  correoContactoConfirmTercero: 'Escriba aquí de nuevo su dirección de correo electrónico',
  telefonoContactoPropio: 'Escriba aquí en números su teléfono de contacto',
  telefonoContactoTercero: 'Escriba aquí en números su teléfono de contacto',
};

const feedbacks = {
  nombre: null,
  tipoDocumento: null,
  documento: null,
  edad: null,
  comunaResidencia: null,
  barrioResidencia: null,
  direccion: null,
  informacionDetalladaAlerta: null,
  lugarSituacionAlerta: null,
  lugarSituacionAlertaOtro: null,
  direccionSituacionAlerta: null,
  materialProbatorio: null,
  nombreContacto: null,
  tipoDocumentoContacto: null,
  documentoContacto: null,
  generoContacto: null,
  edadContacto: null,
  comunaContacto: null,
  barrioContacto: null,
  correoContacto: null,
  correoContactoConfirm: null,
  telefonoContacto: null,
};

const generos = [
  { value: null, text: 'Seleccione', disabled: true },
];

const tiposDocumentos = [
  { value: null, text: 'Seleccione', disabled: true },
];

const orientacionesSexuales = [
  { value: null, text: 'Seleccione', disabled: true },
];

const caracteristicasDiferenciales = [
  { value: 1, text: 'Rural' },
  { value: 2, text: 'Urbano/a' },
  { value: 3, text: 'Campesino/a' },
  { value: 4, text: 'Indígena' },
  { value: 5, text: 'Mestizo' },
  { value: 6, text: 'Afro-colombiano/a' },
  { value: 8, text: 'Isleño/a' },
  { value: 9, text: 'Raizal' },
  { value: 10, text: 'Gitano/a - ROM' },
  { value: 11, text: 'Persona con discapacidad' },
  { value: 12, text: 'Población LGBTI' },
  { value: 13, text: 'Población Migrante' },
  { value: 14, text: 'Víctima del conflicto armado' },
  { value: 15, text: 'No identifica' },
];

const gradosEscolares = [
  { value: null, text: 'Seleccione', disabled: true },
];

const nivelesDeEscolaridad = [
  { value: null, text: 'Seleccione', disabled: true },
];

const numerosHijos = [
  { value: null, text: 'Seleccione', disabled: true },
];

const comunas = [
  { value: null, text: 'Seleccione', disabled: true },
];

const barrios = [
  { value: null, text: 'Seleccione', disabled: true },
];

const lugaresSituacionAlerta = [
  { value: null, text: 'Seleccione', disabled: true },
  { value: 1, text: 'Hogar' },
  { value: 2, text: 'Entorno educativo' },
  { value: 3, text: 'Sitios comunes' },
  { value: 4, text: 'Otra residencia, familiar o conocida' },
  { value: 5, text: 'Otro' },
];

const derechos = [
  { value: 1, text: 'Salud' },
  { value: 2, text: 'Educación' },
  { value: 3, text: 'Alimentación' },
  { value: 4, text: 'Servicios Públicos Domiciliarios' },
  { value: 5, text: 'Vivienda' },
  { value: 6, text: 'Recreación' },
  { value: 7, text: 'Trabajo' },
  { value: 8, text: 'Sexuales y Reproductivos' },
  { value: 9, text: 'Libre Desarrollo de la Personalidad' },
  { value: 10, text: 'A la libertad' },
  { value: 11, text: 'A la vida, riesgo de muerte' },
  { value: 12, text: 'A la identificación personal' },
];

const personasEnRiesgoFields = [
  {
    key: 'nombre',
    label: 'Nombre',
    sortable: true,
  },
  {
    key: 'documento',
    label: 'Número de documento',
    sortable: true,
  },
  {
    key: 'options',
    label: 'Opciones',
    sortable: false,
  },
];

const PRSelectedDefault = {
  nombre: null,
  tipoDocumento: null,
  documento: null,
  genero: null,
  orientacion: null,
  edad: null,
  caracteristicasDiferenciales: [],
  gradoEscolar: null,
  nivelEscolaridad: null,
  esperandoBebe: 0,
  numeroHijos: null,
  comunaResidencia: null,
  barrioResidencia: null,
  direccion: null,
  proteccionDatos: false,
};

export default {
  name: 'FormAlert',
  data() {
    return {
      step: 1,
      file: null,
      invalidFeedback: 'Dato inválido',
      fileAccept: '.jpg, .jpeg, .gif, .png, .doc, .pdf',
      popoverTexts,
      feedbacks,
      generos,
      tiposDocumentos,
      orientacionesSexuales,
      caracteristicasDiferenciales,
      gradosEscolares,
      nivelesDeEscolaridad,
      numerosHijos,
      comunas,
      barrios,
      lugaresSituacionAlerta,
      derechos,
      PRSelected: JSON.parse(JSON.stringify(PRSelectedDefault)),
      PREditing: false,
      showFormPR: true,
      sending: false,
      personasEnRiesgoFields,
      radicado: null,
      form: {
        personasEnRiesgoList: [],
        PersonaEnRiesgo: null,
        geolocalizacion: null,
        enRiesgoViolenciaSexual: 0,
        enRiesgoExplotacionSexual: 0,
        reclutandoUsandoContriniendo: 0,
        debeTrabajar: 0,
        tiempoEnLaCalle: 0,
        viveEnLaCalle: 0,
        problemasConOtros: 0,
        violenciaIntrafamiliar: 0,
        goceEfectivoDerechos: [],
        tieneDepresion: 0,
        sustanciasPsicoactivas: 0,
        sustanciasPsicoactivasAT: 0,
        bajoAmenaza: 0,
        peligroMuerte: 0,
        informacionDetalladaAlerta: null,
        lugarSituacionAlerta: null,
        lugarSituacionAlertaOtro: null,
        direccionSituacionAlerta: null,
        materialProbatorio: [],
        nombreContacto: null,
        tipoDocumentoContacto: null,
        documentoContacto: null,
        generoContacto: null,
        edadContacto: null,
        comunaContacto: null,
        barrioContacto: null,
        correoContacto: null,
        correoContactoConfirm: null,
        telefonoContacto: null,
        proteccionDatos: 'not_accepted',
      },
      anonimo: false,
    };
  },
  computed: {
    vStep2() {
      return !(
        this.vNombre
        && this.vDocumento
        && this.vGenero
        && this.vOrientacion
        && this.vEdad
        && this.vCaracteristicas
        && this.vGradoEscolar
        && this.vNivelEscolaridad
        && this.vNumeroHijos
        && this.vComunaResidencia
        && this.vBarrioResidencia
        && this.vDireccion
        && this.PRSelected.proteccionDatos === 'accepted'
      );
    },
    vStep3() {
      return !(
        this.vInformacionDetalladaAlerta
        && this.vLugarSituacionAlerta
        && this.vdireccionSituacionAlerta
      );
    },
    vStep5() {
      return !(
        (this.vNombreContacto || this.form.PersonaEnRiesgo === 'personal')
        && (this.vDocumentoContacto || this.form.PersonaEnRiesgo === 'personal')
        && (this.vGeneroContacto || this.form.PersonaEnRiesgo === 'personal')
        && (this.vEdadContacto || this.form.PersonaEnRiesgo === 'personal')
        && (this.vComunaContacto || this.form.PersonaEnRiesgo === 'personal')
        && (this.vBarrioContacto || this.form.PersonaEnRiesgo === 'personal')
        && (this.vCorreoContacto || this.vTelefonoContacto)
        && (this.vCorreoContactoConfirm || this.vTelefonoContacto)
        && (this.vTelefonoContacto || this.vCorreoContactoConfirm)
        && (this.form.proteccionDatos === 'accepted' || this.anonimo)
      );
    },
    vNombre() {
      if (this.PRSelected.nombre === null) return null;
      if (this.PRSelected.nombre === '') {
        this.feedbacks.nombre = 'No olvides indicar el nombre de la persona en riesgo.';
        return false;
      }
      if (!expresiones.alphanumeric.test(this.form.nombre)) {
        this.feedbacks.nombre = 'Este campo solo permite caracteres alfanuméricos.';
        return false;
      }
      if (this.PRSelected.nombre.length > 200) {
        this.feedbacks.nombre = 'Por favor indique un nombre que no supere máximo 200 caracteres.';
        return false;
      }
      return true;
    },
    vTipoDocumento() {
      if (this.PRSelected.tipoDocumento === null && this.form.PersonaEnRiesgo !== 'personal') {
        return true;
      }
      if (this.PRSelected.tipoDocumento === null) {
        return null;
      }
      return true;
    },
    vDocumento() {
      if (this.PRSelected.documento === null && this.form.PersonaEnRiesgo === 'tercero') {
        this.PRSelected.documento = '';
      }
      if (this.PRSelected.documento === null) return null;
      if (this.PRSelected.documento === '' && this.form.PersonaEnRiesgo === 'personal') {
        this.feedbacks.documento = 'No olvides indicar el número de documento de la persona en riesgo.';
        return false;
      }
      if (!expresiones.numeric.test(this.PRSelected.documento)) {
        this.feedbacks.documento = 'Este campo solo permite caracteres numéricos.';
        return false;
      }
      if (this.PRSelected.documento.length > 20) {
        this.feedbacks.documento = 'Por favor indique un número que no supere máximo 20 caracteres.';
        return false;
      }
      return true;
    },
    vGenero() {
      if (this.PRSelected.genero === null) {
        return null;
      }
      return true;
    },
    vOrientacion() {
      if (this.PRSelected.orientacion === null) {
        return null;
      }
      return true;
    },
    vEdad() {
      if (this.PRSelected.edad === null && this.form.PersonaEnRiesgo === 'tercero') {
        this.PRSelected.edad = '';
      }
      if (this.PRSelected.edad === null) return null;
      if (this.PRSelected.edad === '' && this.form.PersonaEnRiesgo === 'personal') {
        this.feedbacks.edad = 'No olvides indicar la edad de la persona en riesgo.';
        return false;
      }
      if (!expresiones.numeric.test(this.PRSelected.edad)) {
        this.feedbacks.edad = 'Este campo solo permite caracteres numéricos.';
        return false;
      }
      if (this.PRSelected.edad.length > 3) {
        this.feedbacks.edad = 'Por favor indique un número que no supere máximo 3 caracteres.';
        return false;
      }
      return true;
    },
    vCaracteristicas() {
      if (this.PRSelected.caracteristicasDiferenciales === null && this.form.PersonaEnRiesgo !== 'personal') {
        return true;
      }
      if (this.PRSelected.caracteristicasDiferenciales === null) {
        return null;
      }
      return true;
    },
    vGradoEscolar() {
      if (![1, 2, 3].includes(this.PRSelected.nivelEscolaridad)) {
        return true;
      }
      if (this.PRSelected.gradoEscolar === null && this.form.PersonaEnRiesgo !== 'personal') {
        return true;
      }
      if (this.PRSelected.gradoEscolar === null) {
        return null;
      }
      return true;
    },
    vNivelEscolaridad() {
      if (this.PRSelected.nivelEscolaridad === null && this.form.PersonaEnRiesgo !== 'personal') {
        return true;
      }

      if (this.PRSelected.nivelEscolaridad === null) {
        return null;
      }
      return true;
    },
    vNumeroHijos() {
      if (this.PRSelected.numeroHijos === null && this.form.PersonaEnRiesgo !== 'personal') {
        return true;
      }
      if (this.PRSelected.numeroHijos === null) {
        return null;
      }
      return true;
    },
    vComunaResidencia() {
      if (this.PRSelected.comunaResidencia === null) {
        return null;
      }
      return true;
    },
    vBarrioResidencia() {
      if (this.PRSelected.barrioResidencia === null) {
        return null;
      }
      const inList = this.BarrioResidenciaList.filter(
        (e) => e.value === this.PRSelected.barrioResidencia,
      ).length;

      if (inList > 0) {
        return true;
      }
      return false;
    },
    vDireccion() {
      if (this.PRSelected.direccion === null && this.form.PersonaEnRiesgo === 'tercero') {
        this.PRSelected.direccion = '';
      }
      if (this.PRSelected.direccion === null) return null;
      if (!expresiones.address.test(this.PRSelected.direccion)) {
        this.feedbacks.direccion = 'Este campo solo permite caracteres alfanuméricos o los símbolos: Numeral (#), Guión medio (-)';
        return false;
      }
      if (this.PRSelected.direccion.length > 150) {
        this.feedbacks.direccion = 'Por favor indique un número que no supere máximo 150 caracteres.';
        return false;
      }
      return true;
    },
    vInformacionDetalladaAlerta() {
      if (this.form.informacionDetalladaAlerta === null) {
        return null;
      }
      if (this.form.informacionDetalladaAlerta === '') {
        this.feedbacks.informacionDetalladaAlerta = 'Debes brindar una descripción completa de la situación de alerta.';
        return false;
      }
      if (!expresiones.alphanumeric.test(
        this.form.informacionDetalladaAlerta,
      )) {
        this.feedbacks.informacionDetalladaAlerta = 'Este campo solo permite caracteres alfanuméricos.';
        return false;
      }
      if (this.form.informacionDetalladaAlerta.length > 500) {
        this.feedbacks.informacionDetalladaAlerta = 'Por favor indique un número que no supere máximo 500 caracteres';
        return false;
      }
      return true;
    },
    vLugarSituacionAlerta() {
      if (this.form.lugarSituacionAlerta === null) {
        return null;
      }
      return true;
    },
    vLugarSituacionAlertaOtro() {
      if (this.form.lugarSituacionAlertaOtro === null) {
        return null;
      }
      if (!expresiones.alphanumeric.test(
        this.form.lugarSituacionAlertaOtro,
      )) {
        this.feedbacks.lugarSituacionAlertaOtro = 'Este campo solo permite caracteres alfanuméricos.';
        return false;
      }
      if (this.form.lugarSituacionAlerta.length > 150) {
        this.feedbacks.lugarSituacionAlertaOtro = 'Por favor indique un número que no supere máximo 150 caracteres';
        return false;
      }
      return true;
    },
    vdireccionSituacionAlerta() {
      if (this.form.direccionSituacionAlerta === null) return null;
      if (!expresiones.address.test(this.form.direccionSituacionAlerta)) {
        this.feedbacks.direccionSituacionAlerta = 'Este campo solo permite caracteres alfanuméricos o los símbolos: Numeral (#), Guión medio (-)';
        return false;
      }
      if (this.form.direccionSituacionAlerta.length > 150) {
        this.feedbacks.direccionSituacionAlerta = 'Por favor indique un número que no supere máximo 150 caracteres.';
        return false;
      }
      return true;
    },
    vFile() {
      const maxSize = 16;
      let realSize = 0;

      if (this.file === null) {
        return null;
      }

      this.form.materialProbatorio.forEach((element) => {
        realSize += element.size;
      });

      const accept = this.fileAccept.split(', ');

      const extension = `.${this.file.name.split('.').pop().toLowerCase()}`;

      if (!accept.includes(extension)) {
        this.feedbacks.materialProbatorio = 'Solo se permiten archivos .jpg, .gif, .png, .doc, .pdf';
        return false;
      }

      if (this.file.size + realSize > maxSize / 0.000001) {
        this.feedbacks.materialProbatorio = 'El archivo que está intentando adjuntar tiene más peso que el permitido';
        return false;
      }

      return true;
    },
    vNombreContacto() {
      if (this.form.nombreContacto === null) {
        return null;
      }
      if (this.form.nombreContacto === '') {
        this.feedbacks.nombreContacto = 'No olvides indicar su nombre';
        return false;
      }
      if (!expresiones.alphanumeric.test(this.form.nombreContacto)) {
        this.feedbacks.nombreContacto = 'Este campo solo permite caracteres alfanuméricos';
        return false;
      }

      if (this.form.nombreContacto.length > 200) {
        this.feedbacks.nombreContacto = 'Por favor indique un nombre que no supere máximo 200 caracteres';
        return false;
      }

      return true;
    },
    vTipoDocumentoContacto() {
      if (this.anonimo) {
        return true;
      }
      if (this.form.tipoDocumentoContacto === null && this.form.PersonaEnRiesgo === 'personal') {
        return true;
      }
      if (this.form.tipoDocumentoContacto === null) {
        return null;
      }
      return true;
    },
    vDocumentoContacto() {
      if (this.anonimo) {
        return true;
      }
      if (this.form.documentoContacto === null) {
        return null;
      }
      if (this.form.documentoContacto === '') {
        this.feedbacks.documentoContacto = 'No olvides indicar su número de documento';
        return false;
      }
      if (!expresiones.numeric.test(this.form.documentoContacto)) {
        this.feedbacks.documentoContacto = 'Este campo solo permite caracteres numéricos';
        return false;
      }

      if (this.form.documentoContacto.length > 20) {
        this.feedbacks.documentoContacto = 'Por favor indique un número que no supere máximo 20 caracteres';
        return false;
      }

      return true;
    },
    vGeneroContacto() {
      if (this.anonimo) {
        return true;
      }
      if (this.form.generoContacto === null) {
        return null;
      }

      return true;
    },
    vEdadContacto() {
      if (this.anonimo) {
        return true;
      }
      if (this.form.edadContacto === null) {
        return null;
      }
      if (this.form.edadContacto === '') {
        this.feedbacks.edadContacto = 'No olvides indicar su edad';
        return false;
      }
      if (!expresiones.numeric.test(
        this.form.edadContacto,
      )) {
        this.feedbacks.edadContacto = 'Este campo solo permite caracteres numéricos';
        return false;
      }
      if (this.form.edadContacto.length > 3) {
        this.feedbacks.edadContacto = 'Por favor indique un número que no supere máximo 3 caracteres';
        return false;
      }
      return true;
    },
    vComunaContacto() {
      if (this.anonimo) {
        return true;
      }
      if (this.form.comunaContacto === null) {
        return null;
      }
      return true;
    },
    vBarrioContacto() {
      if (this.anonimo) {
        return true;
      }
      if (this.form.barrioContacto === null) {
        return null;
      }
      const inList = this.BarrioContactoList.filter(
        (e) => e.value === this.form.barrioContacto,
      ).length;

      if (inList > 0) {
        return true;
      }
      return false;
    },
    vCorreoContacto() {
      if (this.anonimo) {
        return true;
      }
      if (this.form.correoContacto === null) {
        return null;
      }
      if (this.form.correoContacto === '') {
        this.feedbacks.correoContacto = 'No olvide indicar su correo electrónico';
        return false;
      }
      if (!expresiones.email.test(
        this.form.correoContacto,
      )) {
        this.feedbacks.correoContacto = 'Este campo solo permite caracteres alfanuméricos y un correo electrónico válido';
        return false;
      }
      if (this.form.correoContacto.length > 150) {
        this.feedbacks.correoContacto = 'Por favor indique un correo electrónico que no supere máximo 150 caracteres';
        return false;
      }
      return true;
    },
    vCorreoContactoConfirm() {
      if (this.anonimo) {
        return true;
      }
      if (this.form.correoContactoConfirm === null) {
        return null;
      }
      if (this.form.correoContactoConfirm === '') {
        this.feedbacks.correoContactoConfirm = 'No olvide indicar nuevamente su correo electrónico';
        return false;
      }
      if (!expresiones.email.test(
        this.form.correoContactoConfirm,
      )) {
        this.feedbacks.correoContactoConfirm = 'Este campo solo permite caracteres alfanuméricos y un correo electrónico válido';
        return false;
      }
      if (this.form.correoContactoConfirm.length > 150) {
        this.feedbacks.correoContactoConfirm = 'Por favor indique un correo electrónico que no supere máximo 150 caracteres';
        return false;
      }
      if (this.form.correoContacto !== this.form.correoContactoConfirm) {
        this.feedbacks.correoContactoConfirm = 'El correo electrónico no coincide con el indicado en el campo anterior.';
        return false;
      }
      return true;
    },
    vTelefonoContacto() {
      if (this.anonimo) {
        return true;
      }
      if (this.form.telefonoContacto === null) {
        return null;
      }
      if (this.form.telefonoContacto === '') {
        this.feedbacks.telefonoContacto = 'No olvides indicar su teléfono de contacto';
        return false;
      }
      if (!expresiones.numeric.test(
        this.form.telefonoContacto,
      )) {
        this.feedbacks.telefonoContacto = 'Este campo solo permite caracteres numéricos';
        return false;
      }
      if (this.form.telefonoContacto.length > 10) {
        this.feedbacks.telefonoContacto = 'Por favor indique un número que no supere máximo 10 caracteres';
        return false;
      }
      return true;
    },
    camposVerificables() {
      const campos = [];

      campos.push({
        nombreSeccion: '¿Quién está en riesgo?',
        step: 1,
        campos: [{
          label: '¿A nombre de quién quieres alertar?',
          value: (this.form.PersonaEnRiesgo === 'personal') ? 'A nombre propio' : 'Por otra persona',
        }],
      });

      let index = 0;
      // eslint-disable-next-line no-restricted-syntax
      for (const p of this.form.personasEnRiesgoList) {
        campos.push({
          nombreSeccion: `Datos de la persona en riesgo (${
            index + 1
          } de ${
            this.form.personasEnRiesgoList.length
          })`,
          step: 2,
          campos: [
            {
              label: (this.form.PersonaEnRiesgo === 'personal')
                ? 'Nombre completo' : 'Nombre de la persona en riesgo',
              value: p.nombre,
            },
            {
              label: (this.form.PersonaEnRiesgo === 'personal')
                ? 'Tipo de documento' : 'Tipo de documento',
              value: (p.tipoDocumento) ? this.tiposDocumentos.find((e) => e.value === p.tipoDocumento).text : '',
            },
            {
              label: (this.form.PersonaEnRiesgo === 'personal')
                ? 'Número de documento' : 'Número de documento de la persona en riesgo',
              value: p.documento,
            },
            {
              label: (this.form.PersonaEnRiesgo === 'personal')
                ? 'Sexo' : 'Sexo de la persona en riesgo',
              value: (p.genero) ? this.generos.find((e) => e.value === p.genero).text : '',
            },
            {
              label: (this.form.PersonaEnRiesgo === 'personal')
                ? 'Orientación sexual' : 'Orientación Sexual de la persona en riesgo',
              value: (p.orientacion) ? this.orientacionesSexuales.find((e) => e.value === p.orientacion).text : '',
            },
            {
              label: (this.form.PersonaEnRiesgo === 'personal')
                ? 'Edad' : 'Edad de la persona en riesgo',
              value: p.edad,
            },
            {
              label: (this.form.PersonaEnRiesgo === 'personal')
                ? 'Características diferenciales' : 'Características diferenciales',
              value: p.caracteristicasDiferenciales,
              type: 'list',
              keys: caracteristicasDiferenciales,
            },
            {
              label: (this.form.PersonaEnRiesgo === 'personal')
                ? 'Grado escolar' : 'Si sabe, por favor indique el grado escolar que tiene la persona en riesgo',
              value: (p.gradoEscolar) ? this.gradosEscolares.find(
                (e) => e.value === p.gradoEscolar,
              ).text : '',
            },
            {
              label: (this.form.PersonaEnRiesgo === 'personal')
                ? '¿Está esperando bebé?' : '¿Sabe si la persona que está en riesgo, está esperando bebé?',
              value: p.esperandoBebe,
              type: 'checkbox',
            },
            {
              label: (this.form.PersonaEnRiesgo === 'personal')
                ? 'Indique el número de hijos, si tiene' : 'Si sabe, por favor indique el número de hijos que tiene la persona en riesgo',
              value: (p.numeroHijos) ? this.numerosHijos.find(
                (e) => e.value === p.numeroHijos,
              ).text : '',
            },
            {
              label: (this.form.PersonaEnRiesgo === 'personal')
                ? 'Comuna donde usted reside' : 'Comuna donde reside la persona en riesgo',
              value: (p.comunaResidencia === null) ? '' : p.comunaResidencia.name,
            },
            {
              label: (this.form.PersonaEnRiesgo === 'personal')
                ? 'Barrio donde usted reside' : 'Barrio donde reside la persona en riesgo',
              value: (p.barrioResidencia === null) ? '' : p.barrioResidencia.name,
            },
            {
              label: (this.form.PersonaEnRiesgo === 'personal')
                ? 'Dirección de su residencia' : 'Dirección de residencia de la persona en riesgo',
              value: p.direccion,
            },
          ],
        });
        index += 1;
      }

      campos.push({
        nombreSeccion: 'Encuesta para conocer su situación de alerta',
        step: 3,
        campos: [
          {
            label: `${(this.form.PersonaEnRiesgo === 'personal') ? '¿Estoy' : '¿Está(n)'} en riesgo de violencia sexual?`,
            value: this.form.enRiesgoViolenciaSexual,
            type: 'checkbox',
          },
          {
            label: `${(this.form.PersonaEnRiesgo === 'personal') ? '¿Estoy' : '¿Está(n)'} en riesgo de explotación sexual?`,
            value: this.form.enRiesgoExplotacionSexual,
            type: 'checkbox',
          },
          {
            label: `${(this.form.PersonaEnRiesgo === 'personal') ? '¿Creo que me están' : '¿Creo que la(s) está(n)'} reclutando, usando, utilizando o constriñendo`,
            value: this.form.reclutandoUsandoContriniendo,
            type: 'checkbox',
          },
          {
            label: `${(this.form.PersonaEnRiesgo === 'personal') ? '¿Pienso que debo' : '¿Piensa(n) que debe(n)'} trabajar`,
            value: this.form.debeTrabajar,
            type: 'checkbox',
          },
          {
            label: `${(this.form.PersonaEnRiesgo === 'personal') ? '¿Permanezco' : '¿Permanece(n)'} mucho tiempo en la calle?`,
            value: this.form.tiempoEnLaCalle,
            type: 'checkbox',
          },
          {
            label: `Actualmente ${(this.form.PersonaEnRiesgo === 'personal') ? '¿Vivo' : '¿Vive(n)'} en la calle?`,
            value: this.form.viveEnLaCalle,
            type: 'checkbox',
          },
          {
            label: `${(this.form.PersonaEnRiesgo === 'personal') ? '¿Tengo' : '¿Tiene(n)'} problemas de convivencia con otras personas`,
            value: this.form.problemasConOtros,
            type: 'checkbox',
          },
          {
            label: `${(this.form.PersonaEnRiesgo === 'personal') ? '¿Tengo' : '¿Tiene(n)'} problemas de violencia intrafamiliar?`,
            value: this.form.violenciaIntrafamiliar,
            type: 'checkbox',
          },
          {
            label: `${(this.form.PersonaEnRiesgo === 'personal') ? '¿Tengo' : '¿Tiene(n)'} dificultades de goce efectivo de derechos? Por favor elija cuáles`,
            value: this.form.goceEfectivoDerechos,
            type: 'list',
            keys: this.derechos,
          },
          {
            label: `${(this.form.PersonaEnRiesgo === 'personal') ? '¿Siento' : '¿Parece que tiene(n)'} depresión, ansiedad u otros problemas relacionados con la salud mental o de ánimo`,
            value: this.form.tieneDepresion,
            type: 'checkbox',
          },
          {
            label: `${(this.form.PersonaEnRiesgo === 'personal') ? '¿Actualmente siento' : '¿Parece que siente(n)'} curiosidad por el consumo de sustancias psicoactivas?: Marihuana, cocaína, popper, 2C-B Tussi b, éxtasis, entre otras`,
            value: this.form.sustanciasPsicoactivas,
            type: 'checkbox',
          },
          {
            label: `${(this.form.PersonaEnRiesgo === 'personal') ? '¿Actualmente siento' : '¿Parece que siente(n)'} curiosidad por el consumo de sustancias psicoactivas? Alcohol y Tabaco`,
            value: this.form.sustanciasPsicoactivasAT,
            type: 'checkbox',
          },
          {
            label: `${(this.form.PersonaEnRiesgo === 'personal') ? '¿Estoy' : '¿Está(n)'} bajo amenaza`,
            value: this.form.bajoAmenaza,
            type: 'checkbox',
          },
          {
            label: `${(this.form.PersonaEnRiesgo === 'personal') ? '¿Estoy' : '¿Está(n)'} en peligro de muerte`,
            value: this.form.peligroMuerte,
            type: 'checkbox',
          },
        ],
      });

      campos.push({
        nombreSeccion: 'Información de la alerta',
        step: 4,
        campos: [
          {
            label: 'Información detallada de la alerta',
            value: this.form.informacionDetalladaAlerta,
          },
          {
            label: 'Lugar donde ocurre la situación de alerta',
            value: (this.form.lugarSituacionAlerta) ? this.lugaresSituacionAlerta.find(
              (e) => e.value === this.form.lugarSituacionAlerta,
            ).text : '',
          },
          {
            label: 'Otro',
            value: this.form.lugarSituacionAlertaOtro,
            disabled: (this.form.lugarSituacionAlerta !== 5),
          },
          {
            label: 'Material probatorio',
            value: this.form.materialProbatorio,
            type: 'files',
          },
        ],
      });

      campos.push({
        nombreSeccion: 'Información de contacto de quien informa la alerta',
        step: 5,
        campos: [
          {
            label: 'Nombre completo',
            value: this.form.nombreContacto,
            disabled: (this.form.PersonaEnRiesgo === 'personal'),
          },
          {
            label: 'Número de documento',
            value: this.form.documentoContacto,
            disabled: (this.form.PersonaEnRiesgo === 'personal'),
          },
          {
            label: 'Sexo',
            disabled: (this.form.PersonaEnRiesgo === 'personal'),
            value: (this.form.generoContacto) ? this.generos.find(
              (e) => e.value === this.form.generoContacto,
            ).text : '',
          },
          {
            label: (this.form.PersonaEnRiesgo === 'personal') ? 'Comuna donde usted reside' : 'Comuna donde reside la persona en riesgo',
            disabled: (this.form.PersonaEnRiesgo === 'personal'),
            value: (this.form.comunaContacto === null) ? '' : this.form.comunaContacto.name,
          },
          {
            label: 'Barrio donde usted reside',
            disabled: (this.form.PersonaEnRiesgo === 'personal'),
            value: (this.form.barrioContacto === null) ? '' : this.form.barrioContacto.name,
          },
          {
            label: 'Correo electrónico',
            value: this.form.correoContacto,
          },
          {
            label: 'Teléfono de contacto',
            value: this.form.telefonoContacto,
          },
        ],
      });

      return campos;
    },
    BarrioResidenciaList() {
      const id = (this.PRSelected.comunaResidencia === null) ? '' : this.PRSelected.comunaResidencia.comuna;
      return this.barrios.filter((e) => (
        e.comunaId === id
        || e.value === null
      ));
    },
    BarrioContactoList() {
      const id = (this.form.comunaContacto === null) ? '' : this.form.comunaContacto.comuna;
      return this.barrios.filter((e) => e.comunaId === id
      || e.value === null);
    },
  },
  methods: {
    next() {
      window.scrollTo(0, 0);
      this.step += 1;
    },
    back() {
      window.scrollTo(0, 0);
      this.step -= 1;
    },
    async enviarFormulario() {
      this.sending = true;
      try {
        const formData = new FormData();

        this.form.materialProbatorio.forEach((e) => {
          formData.append('files[]', e);
        });

        formData.append('data', JSON.stringify(this.form));

        const { data } = await this.$store.state.api.post('alerta', formData);

        if (data.msg === 'saved') {
          this.radicado = data.radicado;
          this.step = 'success';
        } else {
          this.step = 'error';
          this.sending = false;
        }
      } catch (err) {
        this.step = 'error';
        this.sending = false;
      }
    },
    addFile() {
      if (this.file != null) {
        if (this.vFile === true) {
          this.form.materialProbatorio.push(this.file);
          this.file = null;
        }
      }
    },
    addPersonaEnRiesgo() {
      this.form.personasEnRiesgoList.push(this.PRSelected);
      this.PRSelected = JSON.parse(JSON.stringify(PRSelectedDefault));
      this.PREditing = false;
      this.showFormPR = false;
    },
    editPersonaEnRiesgo(data) {
      this.PRSelected = JSON.parse(JSON.stringify(data.item));
      this.form.personasEnRiesgoList.splice(data.index, 1);
      this.PREditing = true;
      this.showFormPR = true;
      setTimeout(() => {
        this.$refs.PRSelectedNombre.focus();
      }, 100);
    },
    showFormPersonaEnRiesgo() {
      this.showFormPR = true;
      setTimeout(() => {
        this.$refs.PRSelectedNombre.focus();
      }, 100);
    },
    async loadComunas() {
      this.comunas = [{
        text: 'Seleccione',
        value: null,
        disabled: true,
      }];
      try {
        const { data } = await Axios.get(this.$store.state.comunasURL);
        data.features.forEach((element) => {
          this.comunas.push({
            value: {
              id: element.attributes.OBJECTID,
              name: `Comuna ${element.attributes.COMUNA} - ${element.attributes.NOMBRE}`,
              comuna: element.attributes.COMUNA,
            },
            text: `Comuna ${element.attributes.COMUNA} - ${element.attributes.NOMBRE}`,
          });
        });
      } catch (err) {
        this.$bvToast.toast('Ocurrió un error intentando consultar las comunas, por favor refresque la página', {
          title: 'Error',
        });
      }
    },
    async loadBarrios() {
      this.barrios = [{
        text: 'Seleccione',
        value: null,
        disabled: true,
      }];
      try {
        const { data } = await Axios.get(this.$store.state.barriosURL);
        data.features.forEach((element) => {
          this.barrios.push({
            value: { id: element.attributes.OBJECTID, name: element.attributes.NOMBRE_BARRIO },
            text: element.attributes.NOMBRE_BARRIO,
            comunaId: element.attributes.COMUNA,
          });
        });
      } catch (err) {
        this.$bvToast.toast('Ocurrió un error intentando consultar los barrios, por favor refresque la página', {
          title: 'Error',
        });
      }
    },
    async loadGeneros() {
      try {
        const { data } = await this.$store.state.api('utils/generos');
        this.generos = [];
        data.forEach((element) => {
          this.generos.push({
            value: element.id,
            text: element.DESCRIPCION,
          });
        });
      } catch (err) {
        this.$bvToast.toast('Ocurrió un error intentando consultar los generos, por favor refresque la página', {
          title: 'Error',
        });
      }
    },
    async loadTiposDocumentos() {
      try {
        const { data } = await this.$store.state.api('utils/tipos-documentos');
        this.tiposDocumentos = [];
        data.forEach((element) => {
          this.tiposDocumentos.push({
            value: element.id,
            text: element.DESCRIPCION,
          });
        });
      } catch (err) {
        this.$bvToast.toast('Ocurrió un error intentando consultar los tiposde documento, por favor refresque la página', {
          title: 'Error',
        });
      }
    },
    async loadOrientaciones() {
      try {
        const { data } = await this.$store.state.api('utils/orientaciones-sexuales');
        this.orientacionesSexuales = [];
        data.forEach((element) => {
          this.orientacionesSexuales.push({
            value: element.id,
            text: element.DESCRIPCION,
          });
        });
      } catch (err) {
        this.$bvToast.toast('Ocurrió un error intentando consultar las orientaciones sexuales, por favor refresque la página', {
          title: 'Error',
        });
      }
    },
    async loadGradosEscolares() {
      try {
        const { data } = await this.$store.state.api('utils/grados-escolares');
        this.gradosEscolares = [];
        data.forEach((element) => {
          this.gradosEscolares.push({
            value: element.id,
            text: element.DESCRIPCION,
          });
        });
      } catch (err) {
        this.$bvToast.toast('Ocurrió un error intentando consultar los grados escolares, por favor refresque la página', {
          title: 'Error',
        });
      }
    },
    async loadNivelesDeEscolaridad() {
      try {
        const { data } = await this.$store.state.api('utils/niveles-escolares');
        this.nivelesDeEscolaridad = [];
        data.forEach((element) => {
          this.nivelesDeEscolaridad.push({
            value: element.id,
            text: element.DESCRIPCION,
          });
        });
      } catch (err) {
        this.$bvToast.toast('Ocurrió un error intentando consultar los niveles de escolaridad, por favor refresque la página', {
          title: 'Error',
        });
      }
    },
    async loadNumeroHijos() {
      try {
        const { data } = await this.$store.state.api('utils/numero-hijos');
        this.numerosHijos = [];
        data.forEach((element) => {
          this.numerosHijos.push({
            value: element.id,
            text: element.DESCRIPCION,
          });
        });
      } catch (err) {
        this.$bvToast.toast('Ocurrió un error intentando consultar la lista de número de hijos, por favor refresque la página', {
          title: 'Error',
        });
      }
    },
  },
  mounted() {
    this.loadBarrios();
    this.loadComunas();
    this.loadGeneros();
    this.loadTiposDocumentos();
    this.loadOrientaciones();
    this.loadNivelesDeEscolaridad();
    this.loadGradosEscolares();
    this.loadNumeroHijos();
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.geolocalizacion = position;
        },
        (err) => {
          // Do someting
        },
      );
    } else {
      // eslint-disable-next-line no-console
      console.log('No existe soporte para Geolocalización');
    }
  },
  watch: {
    anonimo(val) {
      if (val) {
        this.form.nombreContacto = 'ANONIMO';
      } else {
        this.form.nombreContacto = null;
      }
    },
  },
};
</script>
<style scoped>
.slide-fade-enter-active {
  transition: all 0.9s ease;
  transition-delay: 0.2;
}
.slide-fade-leave-active {
  transition: all 0.9s;
}
.slide-fade-enter {
  transform: translateX(10px);
  opacity: 0;
}
.slide-fade-leave-to {
  display: none;
}
.legend {
  font-weight: bold;
}
.nota {
  font-size: 0.8rem;
  font-weight: normal;
  color: gray;
}
.file-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 5px;
}
.dato-box {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
</style>
